import { styled } from '@mui/material/styles'
import { Box, Typography, IconButton } from '@mui/material'
import { MuiButton } from '../../../../components'
import { exportToPPT_tableCss, customScrollBarCss } from '../../../../util'
import { MEDIA } from '../../../../constants'

export const OuterWrapper = styled(Box)(`
    width:100%;
`)

export const ContentInnerWrapper = styled(Box)(`
    border-bottom:1px solid #E0E0E0;
    width:100%;
    display:flex;
`)

const dynamicPadding = (length = 0) => {
  return '2px'
}

export const GridHeaderWrapper = styled(Box)(
  (props) => `
    display:flex;
    width:100%;
    position:relative;
    // z-index:1;
`
)

export const GridOuterWrapper = styled(Box)(
  (props) => `
    width:100%;

    &.isMotivatorsDetractors .tableContainerWrapper {position:relative;}

    // & .typeDriversWithoutSentiments th.headingSentiment { font-size:0 !important; color: #fff;}
`
)

export const ContentWrapper = styled(Box)(
  (props) => `
    width: 100%;
    display: flex;
    flex-direction:column;

    & .legendRoot {padding-bottom:15px;}

    & > div > table > tbody > tr:not(.details) {
        ${props.rowsisselected === 'true' && `background: transparent; box-shadow: none;`}
    }
    // & .level3IsActive .level2Wrapper > .MuiTableContainer-root{ display:none; }
    & .level3IsActive .level3OuterWrapper{ width:100%; display:flex; }
    & .level3IsActive .level3Wrap{ display:flex; flex-direction:row-reverse; }
    // & .level3IsActive .level3Wrap > div{ width:50%; }

    & .level3IsActive .level3Wrap p { padding-left:15px; }
    & .level3IsActive .level3Wrap tr td:first-of-type { padding-left:15px; }
    & .level3IsActive .level3Wrapper.searchActiveButton{border:0; padding-left:0;}
    & .barRoot {max-width:100%;}
    // & .DriverDownloadPPT.theme1.typeSearchDrivers .headingSentiment { font-size: 0 !important }
    // & .typeDriversWithoutSentiments th.headingSentiment { font-size:0 !important; color: #fff !important;}

    ${exportToPPT_tableCss}
`
)

export const ContOuterWrap = styled(Box)(`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: right;
    & > span {
        position:relative;
    }
`)

export const Level1Wrapper = styled(Box)(`
    width: 100%;
    & thead {
        padding:0;
    }
`)

export const Level2Wrapper = styled(Box)(`
    display:flex;
    flex-wrap:wrap;
    padding:0;

    &:before{
        position: absolute;
        right: 0;
        top: -10px;
        width: 0;
        height: 0;
        border: 10px transparent solid;
        border-bottom-color: #fff;
        border-top: 0;
    }
    &.searchActiveButton:before{
        right:50px;  
    }
    &.moreActiveButton:before{
        right:10px;
    }
    & > div {
        padding:0 !important;
        background:transparent;
        margin: 0;
        width: 100%;
    }
    & > div:empty { 
        display: none;
    }
    & ul.Information {
        max-height: 300px;
        ${customScrollBarCss};

        & li {padding-right:8px;}
    }
    & .tableContainerWrapper .headingSentiment {
        width: auto !important;
    }
    & .tableContainerWrapper .headingAttributes {
        display: none;
    }
    & .tableContainerWrapper .headingActions {
        width: 70px;
    }
    & .tableContainerWrapper .details td {
        padding: 0;
    }
    & .actions {
        padding-right:40px;
    }
    
    & .details .selected .headingTitle{
        color: #095BBD;
        font-size: 14px;
        font-weight: 500;
    }

    & .tableContainerWrapper .headingL3 {
        font-size: 17px;
        font-weight: 400;
        min-height: 32px;
        height: 32px;
        line-height: 30px;
        margin-bottom: 8px;
    }

    & .tableContainerWrapper .theme2 td {
        padding: 4px 0;
    }

    & .tableContainerWrapper .level4OuterWrapper {
        padding: 0;

        & .level4Wrapper {
            padding: 0;
            & > div:last-child {
                padding: 0 !important;
                margin: 0;
                background: transparent;
            }
        }
    }

    & .tableContainerWrapper .level3Wrapper .headingL3, & .tableContainerWrapper .level4Wrapper .headingL4 {
        min-height: 36px;
        height: 36px;
        line-height: 36px;
        font-size: 17px;
        font-weight: 300;
    }
    & .tableContainerWrapper .moreActiveButton button { top:0; right:0; }
    & .tableContainerWrapper .searchActiveButton button { top:0; right:0; }

    & > div > table tbody tr:nth-of-type(2n+2) {
        background: transparent;
    }

    &.level2Clickedsearch > div > table tr{
        background: transparent !important;
    }
    
    & > ul.SearchKeyboard, & .imgVidWrapper {
        max-height: 375px;
        ${customScrollBarCss}
    }
    
    & ul.SearchKeyboard > li{
        background: #fff;
        border-radius: 100px;
        border: 1px solid #E7E7E6;
        margin: 0 4px 8px 0;
        list-style: none;
        width: fit-content;
        padding: 10px 20px;
    }

    &.moreActiveButton ul.Information li > span:first-of-type{font-size:14px !important;}

    & .imgWrapper {max-width:300px;}
`)

export const MuiButtonWrap = styled(Box)(`
    position:relative;
`)

export const DetailsHeading = styled(Box)(`
    width:100% !important;
    padding:0;
    font-weight: 600; // 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    display:flex;
    flex-wrap:wrap;
    align-items:center;

    & .pptSubHeading {display:none;}
    & .subheadingL2 {font-size:17px; font-weight: 400; min-height:28px; height:34px; line-height:34px; margin-bottom:8px; }
`)

export const InsightsRteContentWrapper = styled(Box)(`
    width:100% !important;
    padding: 12px 8px !important;
    border: 1px #D8D8D6 solid;
    max-height: 180px;
    margin-bottom: 10px;
    ${customScrollBarCss};
`)

export const InsightsLevel2Details = styled(Box)(`
    padding-top:10px !important;
    width:100% !important;

    & hr {
        display:none;
    }
    & ol, & ul {
        margin-left:25px;
    }
    & li {
        position:relative;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #000;
        line-height:18px;
        padding-bottom:5px;
    }
    
    & ul li ul {
        margin-top:5px;
    }
`)

export const IsDeepDiveImageWrap = styled(Box)(`
    padding:0;
    width:100% !important;
    margin-left:210px;
    max-width:calc(100% - 210px);
    & img {max-width: 100%;}
    @media (max-width: ${MEDIA.lg}) {
        margin-left:180px;
        max-width:calc(100% - 180px);        
    }
`)

export const Level3OuterWrapper = styled(Box)(`
    border: 1px #D8D8D6 solid;
    border-radius: 4px;
    margin-left: -8px;
    width: calc(100% + 16px);
    display:flex;
    padding: 8px;

    & .level3Wrapper {
        border: 0 !important;
    }
    & .headingL3 {
        padding: 0 !important;
    }

    & p {
        font-weight: 400; // 300;
    }
`)

export const Level3Wrapper = styled(Box)(`
    display:flex;
    flex-direction: column;
    width: 100%;
    position:relative;
    &.moreActiveButton{
        background:#F5F5F5;
        padding:0;
        & .verbatimMain > div {
            background: transparent;
            padding: 0 !important;
            margin: 0;
        }
    }
    &.searchActiveButton{
        // padding-left:20px;
        border-left:1px #E0E0E0 solid;
    }
    &.moreActiveButton > button{
        top: 5px;
    }
    & p {
        // padding:0 0 10px 15px;
    }
    & .headingL3 {
        padding-left:10px;
    }
    & > div > table tbody tr:nth-of-type(2n+2) {
        background: transparent;
    }
    & ul.SearchKeyboard{
        // margin-left:15px;
    }
    & .verbatimMain > .MuiBox-root {
      padding : 0 10px !important;
    }

`)

export const Level4OuterWrapper = styled(Box)(`
    display:flex;
    padding:10px;
    position:relative;
    background:#F5F5F5;
    &:empty{
        display:none;
    }
`)

export const Level4Wrapper = styled(Box)(`
    display:flex;
    flex-direction: column;
    width: 100%;
    & > button {
        top:5px;
    }
`)

export const IconButtonWrapper = styled(MuiButton)(`
    position: absolute;
    right: 8px;
    top: 12px;
`)

export const LegendWrapper = styled(Box)(`
    padding-top:15px;
    padding-right: 10px;
    & > div {justify-content:end;}
`)
